import Cookies from "js-cookie";

// 内部语言包 key
export const SUPPORT_LANGS = ["zh-CN", "en-US"];

export const DEFAULT_LANG = "zh-CN";

// cookie locale 值 -> 内部语言包 key 映射：zh-Hans => zh-CN / en => en-US
const LOCALE_MAP = {
  "zh-Hans": "zh-CN",
  "en": "en-US",
};

// 从 cookie 读取 locale（zh-Hans / en）并映射为内部 key，否则返回默认 zh-CN
export function getCurrentLang() {
  const locale = Cookies.get("locale");
  console.log("locale", locale);
  return LOCALE_MAP[locale] || DEFAULT_LANG;
}
